import { Col, Row, Table } from "react-bootstrap";
import { SearchIconSvg } from "../../assets/svg";
import { useCallback, useEffect, useState } from "react";
import { debounce } from "lodash";
import { getAllBookingsTabsData } from "../../api/quotation.api";
import { scrollToTop } from "../../utils/scrollToTop";
import { splitDate } from "../../utils/splitDate";
import ModalWrapper from "../../components/ModalWrapper/ModalWrapper";
import ViewBookingsDetailsModal from "./components/ViewBookingDetailsModal/ViewBookingDetailsModal";
import CustomPagination from "../../components/CustomPagination/Pagination";
import dayjs from "dayjs";
import "./style.scss";

const tableHeader = ['#', 'Booking Number', 'Itinerary Info', 'Total Amount', 'Amount Paid', 'Status', 'Customer Info', 'Staff Info', 'Created At', 'Updated At', ''];

const AllBookings: React.FC = () => {
  const [selectedTab, setSelectedTab] = useState<string>("");
  const [tabData, setTabData] = useState<any>([]);
  const [show, setShow] = useState<boolean>(false);
  const [viewBookingId, setViewBookingId] = useState<any>({});
  
  const [currentPage, setCurrentPage] = useState<number>(1);
  const [totalPages, setTotalPages] = useState<number>(1);

  const [searchText, setSearchText] = useState<string>("");
  const [loading, setLoading] = useState<boolean>(false);

  // const handleTabClick = (tab: string) => {
  //   setTabData([]);
  //   setCurrentPage(1);
  //   setTotalPages(1);
  //   setLoading(true);
  //   setSelectedTab(tab);
  // };
  
  const handleSearchChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const { value } = e.target;
    setTabData([]);
    setLoading(true);
    setSearchText(value);
    debouncedFetchData.cancel();
    if (!!value.trim()) debouncedFetchData(value.trim());
    else {setTabData([]); setLoading(false);}
  };

  const debouncedFetchData = useCallback(
    debounce((searchValue: string) => {
      fetchData(searchValue);
    }, 500),
    []
  );
    
  const fetchData = useCallback(async (searchText: string) => {
    const data = await getAllBookingsTabsData(selectedTab, searchText, currentPage);
    if (data?.status === 200) {
      setTabData([...data?.result?.result]);
      setTotalPages(data?.result?.totalPages);
    }
    setLoading(false);
  }, [selectedTab, currentPage]);
  
  useEffect(() => {
    if (!!searchText.trim()) {
      fetchData(searchText);
      scrollToTop();
    }
    return () => {
      debouncedFetchData.cancel();
    };
  }, [currentPage, selectedTab]);

  const formatNumberWithCommas = (num: any) => {
    return new Intl.NumberFormat('en-IN', { style: "currency", currency: "INR" }).format(num)
  }

  const handleInfoClick = (bookingId: string) => {
    setViewBookingId(bookingId);
    setShow(true);
  }

  return (
    <Row className="my-5 border bg-white rounded m-h-[483px] w-100 m-0">
      <Col className="py-6 px-4" style={{ fontWeight: "700", fontSize: "22px", lineHeight: "28.64px" }}>
        <div className="flex justify-between flex-wrap gap-2 mb-4">
          <h4>All Bookings</h4>
          {
            <div className="flex items-center gap-2 w-1/2 search-global-cont">
              <SearchIconSvg />
              <input
                autoComplete="off"
                className="w-full text-base text-black font-normal focus-visible:outline-none"
                placeholder={`Search by Booking Number, Customer Name, Email , Phone Number`}
                name={"search"}
                onChange={handleSearchChange}
                value={searchText}
              />
            </div>
          }
        </div>
        {/* <div className="flex gap-4 mt-3 mb-4 dash-nav">
          <span className={`cursor-pointer ${selectedTab === "" ? "active" : "text-muted"}`} onClick={() => handleTabClick("")}>All</span>
          <span className={`cursor-pointer ${selectedTab === "RESERVED" ? "active" : "text-muted"}`} onClick={() => handleTabClick("RESERVED")}>Reserved</span>
          <span className={`cursor-pointer ${selectedTab === "ON_HOLD" ? "active" : "text-muted"}`} onClick={() => handleTabClick("ON_HOLD")}>Pending</span>
          <span className={`cursor-pointer ${selectedTab === "CONFIRMED" ? "active" : "text-muted"}`} onClick={() => handleTabClick("CONFIRMED")}>Confirmed</span>
          <span className={`cursor-pointer ${selectedTab === "COMPLETED" ? "active" : "text-muted"}`} onClick={() => handleTabClick("COMPLETED")}>Completed</span>
          <span className={`cursor-pointer ${selectedTab === "CANCELLED" ? "active" : "text-muted"}`} onClick={() => handleTabClick("CANCELLED")}>Cancelled</span>
        </div> */}
        {!!tabData.length ?
          <Table striped bordered responsive>
            <thead className="text-lg">
              <tr className="whitespace-nowrap">
                {tableHeader.map((heading, index) => <th key={index}>{heading}</th>)}
              </tr>
            </thead>
            <tbody className="text-base ">
              {tabData.map((bookingInfo: any, index: number) => (
                  <tr key={bookingInfo?.id} className="whitespace-nowrap font-light">
                      <td>{index + 1}</td>
                      <td ><span className="text-[#92278F]">{bookingInfo?.number}</span></td>
                      <td>
                        <span className="text-sm whitespace-normal">{bookingInfo?.itinerary?.route}</span><br/>
                        <span className="text-sm">
                          {`(${dayjs(splitDate(bookingInfo?.itinerary?.start_time)).format("DD MMM YYYY")} - ${dayjs(splitDate(bookingInfo?.itinerary?.end_time)).format("DD MMM YYYY")})`}
                        </span>
                      </td>
                      <td>{formatNumberWithCommas(bookingInfo?.total)}</td>
                      <td>{formatNumberWithCommas(bookingInfo?.amount_paid)}</td>
                      <td className={`text-${bookingInfo?.status === "CONFIRMED" ? 'success' : bookingInfo?.status === "PARTIAL_PAID" ? 'warning' : 'danger'}`}>{bookingInfo?.status}</td>
                      <td>
                        <div>
                            <strong className="font-medium">Name:</strong> {bookingInfo?.customer?.first_name || 'N/A'} {bookingInfo?.customer?.last_name}<br />
                            <strong className="font-medium">Email:</strong> {bookingInfo?.customer?.email || 'N/A'}<br />
                            <strong className="font-medium">Phone:</strong> {bookingInfo?.customer?.phone_number || 'N/A'}
                        </div>
                      </td>
                      <td>
                        <div>
                            <strong className="font-medium">Name:</strong> {bookingInfo?.staff?.firstName || 'N/A'} {bookingInfo?.staff?.lastName}<br />
                            <strong className="font-medium">Email:</strong> {bookingInfo?.staff?.email || 'N/A'}<br />
                            <strong className="font-medium">Phone:</strong> {bookingInfo?.staff?.phoneNumber || 'N/A'}
                        </div>
                      </td>
                      <td>
                        <div>
                          {new Date(bookingInfo?.created_at).toLocaleDateString("en-GB", {
                            day: "2-digit",
                            month: "short",
                            year: "numeric",
                          }).toString()}<br/>
                          {new Date(bookingInfo?.created_at).toLocaleTimeString("en-US", {
                            hour: "numeric",
                            minute: "numeric",
                            hour12: true,
                          }).toString()}
                        </div>
                        </td>
                      <td>
                        <div>
                          {new Date(bookingInfo?.updated_at).toLocaleDateString("en-GB", {
                            day: "2-digit",
                            month: "short",
                            year: "numeric",
                          }).toString()}<br/>
                          {new Date(bookingInfo?.updated_at).toLocaleTimeString("en-US", {
                            hour: "numeric",
                            minute: "numeric",
                            hour12: true,
                          }).toString()}
                        </div>
                      </td>
                      <td><span onClick={() => handleInfoClick(bookingInfo?.id)} className="cursor-pointer text-[#d0566e]">More Info &gt;</span></td>
                  </tr>
              ))}
            </tbody>
          </Table> : 
          loading ? <div className="spinner-boxes"></div> : <p className="text-center my-2 text-muted">{searchText ? "No Bookings Found" : "Search for Booking Details🔎"}</p>}
        {!!tabData.length && <div className="mt-4"><CustomPagination currentPage={currentPage} setCurrentPage={setCurrentPage} totalPages={totalPages}/></div>}
      </Col>
      <ModalWrapper show={show} handleClose={() => setShow(false)} clx={'view-booking-detail-modal-wrapper'}>
        <ViewBookingsDetailsModal bookingId={viewBookingId} />
      </ModalWrapper>
    </Row>
  );
};

export default AllBookings;
